import { call, put, select } from "redux-saga/effects";
import { selectUser } from "../../features/auth/authSlice";
import { User } from "../../types/User";
import {
  setError as setDashError,
  setStatus as setDashStatus,
  setFactotumStateTies,
  setFactotumStates,
  setFactotums,
} from "../../features/library/librarySlice";
import * as actions from "../actions";

import {
  apiCreateFactotum,
  apiCreateFactotumState,
  apiCreateFactotumStateTie,
  apiGetFactotumStateTies,
  apiGetFactotumStates,
  apiGetFactotums,
  apiUpdateFactotum,
  apiUpdateFactotumState,
} from "../../services/FactotumAPI";

export function* createFactotum(
  action: ReturnType<typeof actions.createFactotum>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    yield call(
      apiCreateFactotum,
      userState.default_organization_id,
      userState.default_workspace_id,
      action.payload
    );

    yield put(actions.getFactotums());
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* getFactotums() {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    const response = yield call(
      apiGetFactotums,
      userState.default_organization_id,
      userState.default_workspace_id
    );

    yield put(setFactotums(response.data.factotums ?? []));

    yield put(setDashStatus({ status: "idle", error: undefined }));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* updateFactotum(
  action: ReturnType<typeof actions.updateFactotum>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    yield call(
      apiUpdateFactotum,
      userState.default_organization_id,
      userState.default_workspace_id,
      action.payload.factotumId,
      action.payload.factotumUpdateRequest
    );

    yield put(actions.getFactotums());
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* getFactotumStates(
  action: ReturnType<typeof actions.getFactotumStates>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    const response = yield call(
      apiGetFactotumStates,
      userState.default_organization_id,
      action.payload
    );

    yield put(setFactotumStates(response.data.states ?? []));

    yield put(setDashStatus({ status: "idle", error: undefined }));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* createFactotumState(
  action: ReturnType<typeof actions.createFactotumState>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    yield call(
      apiCreateFactotumState,
      userState.default_organization_id,
      action.payload.factotumId,
      action.payload.factotumStateCreateRequest
    );

    yield put(actions.getFactotumStates(action.payload.factotumId));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* updateFactotumState(
  action: ReturnType<typeof actions.updateFactotumState>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    yield call(
      apiUpdateFactotumState,
      userState.default_organization_id,
      action.payload.factotumId,
      action.payload.stateId,
      action.payload.factotumStateUpdateRequest
    );

    yield put(actions.getFactotumStates(action.payload.factotumId));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* getFactotumStateTies(
  action: ReturnType<typeof actions.getFactotumStateTies>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    const response = yield call(
      apiGetFactotumStateTies,
      userState.default_organization_id,
      action.payload
    );

    yield put(setFactotumStateTies(response.data.state_ties ?? []));

    yield put(setDashStatus({ status: "idle", error: undefined }));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}

export function* createFactotumStateTie(
  action: ReturnType<typeof actions.createFactotumStateTie>
) {
  yield put(setDashStatus({ status: "loading", error: undefined }));

  try {
    const userState = (yield select(selectUser)) as User;
    yield call(
      apiCreateFactotumStateTie,
      userState.default_organization_id,
      action.payload.factotumId,
      action.payload.factotumStateTieCreateRequest
    );

    yield put(actions.getFactotumStateTies(action.payload.factotumId));
  } catch (e) {
    yield put(setDashError(String(e)));
    return;
  }
}
